import { findEntry } from "../routes/switchboard";
import type { SwitchEntry } from "../routes/switchboard";

/** Which Help the switchboard serves: the new page ("next") or today's pop-up ("legacy"). One line, `/help`, decides the menu entry, the "How does this work?" links and the dot. */
export type HelpMode = SwitchEntry["mode"];
export const helpMode = (board?: SwitchEntry[]): HelpMode => findEntry("/help", board)?.entry.mode ?? "legacy";
